/** Parents avec défilement (overflow auto/scroll) — pour repositionner ou suivre un menu ancré au déclencheur. */
export function getScrollableAncestors(el: HTMLElement | null): HTMLElement[] {
  const out: HTMLElement[] = [];
  let p: HTMLElement | null = el?.parentElement ?? null;
  while (p && p !== document.body) {
    const st = getComputedStyle(p);
    const oy = st.overflowY;
    const ox = st.overflowX;
    const o = st.overflow;
    if (/(auto|scroll|overlay)/.test(`${o}${oy}${ox}`)) out.push(p);
    p = p.parentElement;
  }
  out.push(document.documentElement);
  return out;
}
